import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Switch Icon Style 02 - Toggle On/Off (Material Symbol)
 * - isOn = true: 綠色 toggle_on
 * - isOn = false: 灰色 toggle_off
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:toggle_on
 */
export const Style02_ToggleOn: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-green-500' : 'text-slate-400';
  const iconName = isOn ? 'toggle_on' : 'toggle_off';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      {iconName}
    </span>
  );
};

export default Style02_ToggleOn;
